import createRoute from '@widesk-ui/tools/createRoute';
import StandModel  from '@models/website/StandModel';

const route = createRoute.dashboard(
	'/website_entertainments/:websiteEntertainmentId/stands/mode/:mode',
	'website',
	'StandDashboard',
	StandModel.localize(),
);
export default route;
